import { CheckCircle, HelpOutline, RemoveCircle } from "@mui/icons-material";

import { If } from "../If";

export type CustomerServerHealthStatus = "online" | "offline" | "not_provisioned";

export interface CustomerServerHealth {
    status: CustomerServerHealthStatus;
    is_running: boolean;
}

interface CustomerServerHealthStatusProps {
    health: CustomerServerHealth | null;
    loading: boolean;
    className?: string;
    iconClassName?: string;
}

export function normalizeCustomerServerHealth(
    response: unknown
): CustomerServerHealth | null {
    if (response === null || response === undefined) {
        return null;
    }

    if (typeof response === "boolean") {
        return {
            status: response ? "online" : "offline",
            is_running: response,
        };
    }

    if (typeof response === "object" && response !== null && "status" in response) {
        const data = response as CustomerServerHealth;

        if (
            data.status === "online" ||
            data.status === "offline" ||
            data.status === "not_provisioned"
        ) {
            return data;
        }
    }

    return null;
}

export function customerHasServer(
    health: CustomerServerHealth | null,
    customer?: {
        generated_id?: number | string | null;
        server_id?: number | string | null;
    } | null
): boolean {
    if (health?.status === "not_provisioned") {
        return Boolean(customer?.server_id);
    }

    return (
        health?.status === "online" ||
        health?.status === "offline" ||
        Boolean(customer?.server_id)
    );
}

export function CustomerServerHealthStatus({
    health,
    loading,
    className,
    iconClassName = "icon",
}: CustomerServerHealthStatusProps) {
    if (loading || !health) {
        return null;
    }

    if (health.status === "not_provisioned") {
        return (
            <span className={className}>
                <If condition={!loading}>
                    <span className={iconClassName}>
                        <HelpOutline color="warning" />
                    </span>
                    <span>
                        Servidor{" "}
                        <strong>NÃO CRIADO</strong>
                        <br />
                        <span
                            style={{
                                fontSize: "0.6rem",
                                textAlign: "right",
                            }}
                        >
                            consultado agora
                        </span>
                    </span>
                </If>
            </span>
        );
    }

    if (health.status === "online") {
        return (
            <span className={className}>
                <If condition={!loading}>
                    <CheckCircle color="success" />
                    <span>
                        Cliente está <strong>ONLINE</strong>
                        <br />
                        <span
                            style={{
                                fontSize: "0.6rem",
                                textAlign: "right",
                            }}
                        >
                            consultado agora
                        </span>
                    </span>
                </If>
            </span>
        );
    }

    return (
        <span className={className}>
            <If condition={!loading}>
                <span className={iconClassName}>
                    <RemoveCircle color="error" />
                </span>
                <span>
                    Cliente está <strong>OFFLINE</strong>
                    <br />
                    <span
                        style={{
                            fontSize: "0.6rem",
                            textAlign: "right",
                        }}
                    >
                        consultado agora
                    </span>
                </span>
            </If>
        </span>
    );
}
